import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BusinessEntity  {
    _originalTypeClassName = "zERP.BO.BusinessEntity";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BusinessEntity.translate = translateService;
}
this.Departments = [];
this.Brances = [];
this.SubCompanies = [];
this.TaxOfficeSICs = [];
this.BankAccounts = [];
this.Addresses = [];
this.CashAccounts = [];
this.Holidays = [];
this.MainInsuranceFund = [];
this.SubsidiaryInsuranceFund = [];
this.OccupationalPhysicians = [];
this.SecurityTechnicians = [];
this.Location = [];
this.BusinessEntityErganiSIC = [];
this.Id = null;
this.Name = null;
this.ShortName = null;
this.Description = null;
this.BranchNumber = null;
this.PublicSector = false;
this.TaxNumber = null;
this.StartDate = null;
this.Status = null;
this.Kind = null;
this.TerminationDate = null;
this.TerminationReason = null;
this.BookType = null;
this.AdministrationStartPeriod = null;
this.AdministrationEndPeriod = null;
this.HasTax = false;
this.AME = null;
this.AADEUser = null;
this.AADEKey = null;
this.ErganiUser = null;
this.ErganiPassword = null;
this.EFKA_Code = null;
this.EFKA_Branch = null;
this.EFKA_LegalEntityName = null;
this.EFKA_IndividualName = null;
this.EFKA_IndividualFatherName = null;
this.IntraCommunityTransactions = false;
this.InheritBankAccount = false;
this.InheritsOccupationalPhysicians = false;
this.InheritsSecurityTechnicians = false;
this.InheritsRepresentationDetails = false;
this.InheritsEmploymentLabourDetails = false;
this.InheritsMainInsuranceFund = false;
this.InheritsSubsidiaryInsuranceFund = false;
this.SEPE_Code = null;
this.OAED_Code = null;
this.CostCenterFrom = null;
this.CostCenterTo = null;
this.CurrencyDecimalAccuracy = null;
this.Code = null;
this.ErgodotikiOrganosi = null;
this.EapCode = null;
this.RegularBudgetWeight = false;
this.Cap_TAXDIK = null;
this.BusinessActivity = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
ShortName:any;
Description:any;
BranchNumber:any;
PublicSector:any;
TaxNumber:any;
StartDate:any;
Status:any;
Kind:any;
TerminationDate:any;
TerminationReason:any;
BookType:any;
AdministrationStartPeriod:any;
AdministrationEndPeriod:any;
HasTax:any;
AME:any;
AADEUser:any;
AADEKey:any;
ErganiUser:any;
ErganiPassword:any;
EFKA_Code:any;
EFKA_Branch:any;
EFKA_LegalEntityName:any;
EFKA_IndividualName:any;
EFKA_IndividualFatherName:any;
IntraCommunityTransactions:any;
InheritBankAccount:any;
InheritsOccupationalPhysicians:any;
InheritsSecurityTechnicians:any;
InheritsRepresentationDetails:any;
InheritsEmploymentLabourDetails:any;
InheritsMainInsuranceFund:any;
InheritsSubsidiaryInsuranceFund:any;
SEPE_Code:any;
OAED_Code:any;
CostCenterFrom:any;
CostCenterTo:any;
CurrencyDecimalAccuracy:any;
Code:any;
ErgodotikiOrganosi:any;
EapCode:any;
RegularBudgetWeight:any;
Cap_TAXDIK:any;
BusinessActivity:any;
ContactDetails:any;
DefaultCurrency:any;
Departments:any;
TaxOffice:any;
Type:any;
BranchOwner:any;
Brances:any;
ParentCompany:any;
SubCompanies:any;
Country:any;
TaxOfficeSICs:any;
BankAccounts:any;
Addresses:any;
CashAccounts:any;
Holidays:any;
RepresentationDetail:any;
EmploymentAndLabourDetail:any;
MainInsuranceFund:any;
SubsidiaryInsuranceFund:any;
OccupationalPhysicians:any;
SecurityTechnicians:any;
PayrollBankAccount:any;
DefaultBankAccount:any;
Location:any;
CostCenter:any;
TaxAddress:any;
SEPE_Branch:any;
DYPA_Branch:any;
BusinessEntityErganiSIC:any;
SEPE_DimotikiEnotita:any;
static setContactDetails = ($this, value) => {
var oldValue = $this.ContactDetails;
$this.ContactDetails = value;
if (value != null) {
}
}
static setDefaultCurrency = ($this, value) => {
var oldValue = $this.DefaultCurrency;
$this.DefaultCurrency = value;
if (value != null) {
}
}
static setDepartments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Departments == null) $this.Departments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Departments.length > 0) {
                    Domain.BusinessEntity.removeDepartments($this, $this.Departments[0]);
                }

                Domain.BusinessEntity.addManyDepartments($this, copyItems);
            }
static addManyDepartments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addDepartments($this, items[i]);
                }
            }
static addDepartments = ($this, item) => {
                if ($this.Departments == null) $this.Departments = [];
                if (item == null || $this.Departments.indexOf(item) > -1) return;
                $this.Departments.push(item);
if (item.Company != $this) {
Domain.Department.setCompany(item, $this);
}
}
static addRangeDepartments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addDepartments($this, item));
            }
static removeDepartments = ($this, item) => {
                if ($this == null || $this.Departments == null || $this.Departments.indexOf(item) === -1) return;
                var _index = $this.Departments.indexOf(item);
                $this.Departments.splice(_index, 1);
item.Company = null;
}
static clearDepartments = ($this) => { $this.Departments = null; }
static setTaxOffice = ($this, value) => {
var oldValue = $this.TaxOffice;
$this.TaxOffice = value;
if (value != null) {
}
}
static setType = ($this, value) => {
var oldValue = $this.Type;
$this.Type = value;
if (value != null) {
}
}
static setBranchOwner = ($this, value) => {
var oldValue = $this.BranchOwner;
$this.BranchOwner = value;
if (value != null) {
if (oldValue != null) {
Domain.BusinessEntity.removeBrances(oldValue, $this);
}
Domain.BusinessEntity.addBrances(value, $this);
}
}
static setBrances = ($this, items) => {
                if (items == null) items = [];
                if ($this.Brances == null) $this.Brances = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Brances.length > 0) {
                    Domain.BusinessEntity.removeBrances($this, $this.Brances[0]);
                }

                Domain.BusinessEntity.addManyBrances($this, copyItems);
            }
static addManyBrances = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addBrances($this, items[i]);
                }
            }
static addBrances = ($this, item) => {
                if ($this.Brances == null) $this.Brances = [];
                if (item == null || $this.Brances.indexOf(item) > -1) return;
                $this.Brances.push(item);
if (item.BranchOwner != $this) {
Domain.BusinessEntity.setBranchOwner(item, $this);
}
}
static addRangeBrances = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addBrances($this, item));
            }
static removeBrances = ($this, item) => {
                if ($this == null || $this.Brances == null || $this.Brances.indexOf(item) === -1) return;
                var _index = $this.Brances.indexOf(item);
                $this.Brances.splice(_index, 1);
item.BranchOwner = null;
}
static clearBrances = ($this) => { $this.Brances = null; }
static setParentCompany = ($this, value) => {
var oldValue = $this.ParentCompany;
$this.ParentCompany = value;
if (value != null) {
if (oldValue != null) {
Domain.BusinessEntity.removeSubCompanies(oldValue, $this);
}
Domain.BusinessEntity.addSubCompanies(value, $this);
}
}
static setSubCompanies = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubCompanies == null) $this.SubCompanies = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubCompanies.length > 0) {
                    Domain.BusinessEntity.removeSubCompanies($this, $this.SubCompanies[0]);
                }

                Domain.BusinessEntity.addManySubCompanies($this, copyItems);
            }
static addManySubCompanies = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addSubCompanies($this, items[i]);
                }
            }
static addSubCompanies = ($this, item) => {
                if ($this.SubCompanies == null) $this.SubCompanies = [];
                if (item == null || $this.SubCompanies.indexOf(item) > -1) return;
                $this.SubCompanies.push(item);
if (item.ParentCompany != $this) {
Domain.BusinessEntity.setParentCompany(item, $this);
}
}
static addRangeSubCompanies = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addSubCompanies($this, item));
            }
static removeSubCompanies = ($this, item) => {
                if ($this == null || $this.SubCompanies == null || $this.SubCompanies.indexOf(item) === -1) return;
                var _index = $this.SubCompanies.indexOf(item);
                $this.SubCompanies.splice(_index, 1);
item.ParentCompany = null;
}
static clearSubCompanies = ($this) => { $this.SubCompanies = null; }
static setCountry = ($this, value) => {
var oldValue = $this.Country;
$this.Country = value;
if (value != null) {
}
}
static setTaxOfficeSICs = ($this, items) => {
                if (items == null) items = [];
                if ($this.TaxOfficeSICs == null) $this.TaxOfficeSICs = [];

                const copyItems = Common.cloneObject(items);

                while ($this.TaxOfficeSICs.length > 0) {
                    Domain.BusinessEntity.removeTaxOfficeSICs($this, $this.TaxOfficeSICs[0]);
                }

                Domain.BusinessEntity.addManyTaxOfficeSICs($this, copyItems);
            }
static addManyTaxOfficeSICs = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addTaxOfficeSICs($this, items[i]);
                }
            }
static addTaxOfficeSICs = ($this, item) => {
                if ($this.TaxOfficeSICs == null) $this.TaxOfficeSICs = [];
                if (item == null || $this.TaxOfficeSICs.indexOf(item) > -1) return;
                $this.TaxOfficeSICs.push(item);
}
static addRangeTaxOfficeSICs = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addTaxOfficeSICs($this, item));
            }
static removeTaxOfficeSICs = ($this, item) => {
                if ($this == null || $this.TaxOfficeSICs == null || $this.TaxOfficeSICs.indexOf(item) === -1) return;
                var _index = $this.TaxOfficeSICs.indexOf(item);
                $this.TaxOfficeSICs.splice(_index, 1);
}
static clearTaxOfficeSICs = ($this) => { $this.TaxOfficeSICs = null; }
static setBankAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.BankAccounts == null) $this.BankAccounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.BankAccounts.length > 0) {
                    Domain.BusinessEntity.removeBankAccounts($this, $this.BankAccounts[0]);
                }

                Domain.BusinessEntity.addManyBankAccounts($this, copyItems);
            }
static addManyBankAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addBankAccounts($this, items[i]);
                }
            }
static addBankAccounts = ($this, item) => {
                if ($this.BankAccounts == null) $this.BankAccounts = [];
                if (item == null || $this.BankAccounts.indexOf(item) > -1) return;
                $this.BankAccounts.push(item);
if (item.Entity != $this) {
Domain.BankAccount.setEntity(item, $this);
}
}
static addRangeBankAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addBankAccounts($this, item));
            }
static removeBankAccounts = ($this, item) => {
                if ($this == null || $this.BankAccounts == null || $this.BankAccounts.indexOf(item) === -1) return;
                var _index = $this.BankAccounts.indexOf(item);
                $this.BankAccounts.splice(_index, 1);
item.Entity = null;
}
static clearBankAccounts = ($this) => { $this.BankAccounts = null; }
static setAddresses = ($this, items) => {
                if (items == null) items = [];
                if ($this.Addresses == null) $this.Addresses = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Addresses.length > 0) {
                    Domain.BusinessEntity.removeAddresses($this, $this.Addresses[0]);
                }

                Domain.BusinessEntity.addManyAddresses($this, copyItems);
            }
static addManyAddresses = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addAddresses($this, items[i]);
                }
            }
static addAddresses = ($this, item) => {
                if ($this.Addresses == null) $this.Addresses = [];
                if (item == null || $this.Addresses.indexOf(item) > -1) return;
                $this.Addresses.push(item);
}
static addRangeAddresses = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addAddresses($this, item));
            }
static removeAddresses = ($this, item) => {
                if ($this == null || $this.Addresses == null || $this.Addresses.indexOf(item) === -1) return;
                var _index = $this.Addresses.indexOf(item);
                $this.Addresses.splice(_index, 1);
}
static clearAddresses = ($this) => { $this.Addresses = null; }
static setCashAccounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.CashAccounts == null) $this.CashAccounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.CashAccounts.length > 0) {
                    Domain.BusinessEntity.removeCashAccounts($this, $this.CashAccounts[0]);
                }

                Domain.BusinessEntity.addManyCashAccounts($this, copyItems);
            }
static addManyCashAccounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addCashAccounts($this, items[i]);
                }
            }
static addCashAccounts = ($this, item) => {
                if ($this.CashAccounts == null) $this.CashAccounts = [];
                if (item == null || $this.CashAccounts.indexOf(item) > -1) return;
                $this.CashAccounts.push(item);
if (item.Entity != $this) {
Domain.CashAccount.setEntity(item, $this);
}
}
static addRangeCashAccounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addCashAccounts($this, item));
            }
static removeCashAccounts = ($this, item) => {
                if ($this == null || $this.CashAccounts == null || $this.CashAccounts.indexOf(item) === -1) return;
                var _index = $this.CashAccounts.indexOf(item);
                $this.CashAccounts.splice(_index, 1);
item.Entity = null;
}
static clearCashAccounts = ($this) => { $this.CashAccounts = null; }
static setHolidays = ($this, items) => {
                if (items == null) items = [];
                if ($this.Holidays == null) $this.Holidays = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Holidays.length > 0) {
                    Domain.BusinessEntity.removeHolidays($this, $this.Holidays[0]);
                }

                Domain.BusinessEntity.addManyHolidays($this, copyItems);
            }
static addManyHolidays = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addHolidays($this, items[i]);
                }
            }
static addHolidays = ($this, item) => {
                if ($this.Holidays == null) $this.Holidays = [];
                if (item == null || $this.Holidays.indexOf(item) > -1) return;
                $this.Holidays.push(item);
if (item.Entity != $this) {
Domain.Holiday.setEntity(item, $this);
}
}
static addRangeHolidays = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addHolidays($this, item));
            }
static removeHolidays = ($this, item) => {
                if ($this == null || $this.Holidays == null || $this.Holidays.indexOf(item) === -1) return;
                var _index = $this.Holidays.indexOf(item);
                $this.Holidays.splice(_index, 1);
item.Entity = null;
}
static clearHolidays = ($this) => { $this.Holidays = null; }
static setRepresentationDetail = ($this, value) => {
var oldValue = $this.RepresentationDetail;
$this.RepresentationDetail = value;
if (value != null) {
}
}
static setEmploymentAndLabourDetail = ($this, value) => {
var oldValue = $this.EmploymentAndLabourDetail;
$this.EmploymentAndLabourDetail = value;
if (value != null) {
}
}
static setMainInsuranceFund = ($this, items) => {
                if (items == null) items = [];
                if ($this.MainInsuranceFund == null) $this.MainInsuranceFund = [];

                const copyItems = Common.cloneObject(items);

                while ($this.MainInsuranceFund.length > 0) {
                    Domain.BusinessEntity.removeMainInsuranceFund($this, $this.MainInsuranceFund[0]);
                }

                Domain.BusinessEntity.addManyMainInsuranceFund($this, copyItems);
            }
static addManyMainInsuranceFund = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addMainInsuranceFund($this, items[i]);
                }
            }
static addMainInsuranceFund = ($this, item) => {
                if ($this.MainInsuranceFund == null) $this.MainInsuranceFund = [];
                if (item == null || $this.MainInsuranceFund.indexOf(item) > -1) return;
                $this.MainInsuranceFund.push(item);
}
static addRangeMainInsuranceFund = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addMainInsuranceFund($this, item));
            }
static removeMainInsuranceFund = ($this, item) => {
                if ($this == null || $this.MainInsuranceFund == null || $this.MainInsuranceFund.indexOf(item) === -1) return;
                var _index = $this.MainInsuranceFund.indexOf(item);
                $this.MainInsuranceFund.splice(_index, 1);
}
static clearMainInsuranceFund = ($this) => { $this.MainInsuranceFund = null; }
static setSubsidiaryInsuranceFund = ($this, items) => {
                if (items == null) items = [];
                if ($this.SubsidiaryInsuranceFund == null) $this.SubsidiaryInsuranceFund = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SubsidiaryInsuranceFund.length > 0) {
                    Domain.BusinessEntity.removeSubsidiaryInsuranceFund($this, $this.SubsidiaryInsuranceFund[0]);
                }

                Domain.BusinessEntity.addManySubsidiaryInsuranceFund($this, copyItems);
            }
static addManySubsidiaryInsuranceFund = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addSubsidiaryInsuranceFund($this, items[i]);
                }
            }
static addSubsidiaryInsuranceFund = ($this, item) => {
                if ($this.SubsidiaryInsuranceFund == null) $this.SubsidiaryInsuranceFund = [];
                if (item == null || $this.SubsidiaryInsuranceFund.indexOf(item) > -1) return;
                $this.SubsidiaryInsuranceFund.push(item);
}
static addRangeSubsidiaryInsuranceFund = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addSubsidiaryInsuranceFund($this, item));
            }
static removeSubsidiaryInsuranceFund = ($this, item) => {
                if ($this == null || $this.SubsidiaryInsuranceFund == null || $this.SubsidiaryInsuranceFund.indexOf(item) === -1) return;
                var _index = $this.SubsidiaryInsuranceFund.indexOf(item);
                $this.SubsidiaryInsuranceFund.splice(_index, 1);
}
static clearSubsidiaryInsuranceFund = ($this) => { $this.SubsidiaryInsuranceFund = null; }
static setOccupationalPhysicians = ($this, items) => {
                if (items == null) items = [];
                if ($this.OccupationalPhysicians == null) $this.OccupationalPhysicians = [];

                const copyItems = Common.cloneObject(items);

                while ($this.OccupationalPhysicians.length > 0) {
                    Domain.BusinessEntity.removeOccupationalPhysicians($this, $this.OccupationalPhysicians[0]);
                }

                Domain.BusinessEntity.addManyOccupationalPhysicians($this, copyItems);
            }
static addManyOccupationalPhysicians = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addOccupationalPhysicians($this, items[i]);
                }
            }
static addOccupationalPhysicians = ($this, item) => {
                if ($this.OccupationalPhysicians == null) $this.OccupationalPhysicians = [];
                if (item == null || $this.OccupationalPhysicians.indexOf(item) > -1) return;
                $this.OccupationalPhysicians.push(item);
}
static addRangeOccupationalPhysicians = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addOccupationalPhysicians($this, item));
            }
static removeOccupationalPhysicians = ($this, item) => {
                if ($this == null || $this.OccupationalPhysicians == null || $this.OccupationalPhysicians.indexOf(item) === -1) return;
                var _index = $this.OccupationalPhysicians.indexOf(item);
                $this.OccupationalPhysicians.splice(_index, 1);
}
static clearOccupationalPhysicians = ($this) => { $this.OccupationalPhysicians = null; }
static setSecurityTechnicians = ($this, items) => {
                if (items == null) items = [];
                if ($this.SecurityTechnicians == null) $this.SecurityTechnicians = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SecurityTechnicians.length > 0) {
                    Domain.BusinessEntity.removeSecurityTechnicians($this, $this.SecurityTechnicians[0]);
                }

                Domain.BusinessEntity.addManySecurityTechnicians($this, copyItems);
            }
static addManySecurityTechnicians = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addSecurityTechnicians($this, items[i]);
                }
            }
static addSecurityTechnicians = ($this, item) => {
                if ($this.SecurityTechnicians == null) $this.SecurityTechnicians = [];
                if (item == null || $this.SecurityTechnicians.indexOf(item) > -1) return;
                $this.SecurityTechnicians.push(item);
}
static addRangeSecurityTechnicians = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addSecurityTechnicians($this, item));
            }
static removeSecurityTechnicians = ($this, item) => {
                if ($this == null || $this.SecurityTechnicians == null || $this.SecurityTechnicians.indexOf(item) === -1) return;
                var _index = $this.SecurityTechnicians.indexOf(item);
                $this.SecurityTechnicians.splice(_index, 1);
}
static clearSecurityTechnicians = ($this) => { $this.SecurityTechnicians = null; }
static setPayrollBankAccount = ($this, value) => {
var oldValue = $this.PayrollBankAccount;
$this.PayrollBankAccount = value;
if (value != null) {
}
}
static setDefaultBankAccount = ($this, value) => {
var oldValue = $this.DefaultBankAccount;
$this.DefaultBankAccount = value;
if (value != null) {
}
}
static setLocation = ($this, items) => {
                if (items == null) items = [];
                if ($this.Location == null) $this.Location = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Location.length > 0) {
                    Domain.BusinessEntity.removeLocation($this, $this.Location[0]);
                }

                Domain.BusinessEntity.addManyLocation($this, copyItems);
            }
static addManyLocation = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addLocation($this, items[i]);
                }
            }
static addLocation = ($this, item) => {
                if ($this.Location == null) $this.Location = [];
                if (item == null || $this.Location.indexOf(item) > -1) return;
                $this.Location.push(item);
}
static addRangeLocation = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addLocation($this, item));
            }
static removeLocation = ($this, item) => {
                if ($this == null || $this.Location == null || $this.Location.indexOf(item) === -1) return;
                var _index = $this.Location.indexOf(item);
                $this.Location.splice(_index, 1);
}
static clearLocation = ($this) => { $this.Location = null; }
static setCostCenter = ($this, value) => {
var oldValue = $this.CostCenter;
$this.CostCenter = value;
if (value != null) {
if (oldValue != null && oldValue.BusinessEntity != null) { oldValue.BusinessEntity = null; }
if ($this.CostCenter.BusinessEntity !== $this) {
Domain.CostCenter.setBusinessEntity(value, $this);
}
}
}
static setTaxAddress = ($this, value) => {
var oldValue = $this.TaxAddress;
$this.TaxAddress = value;
if (value != null) {
}
}
static setSEPE_Branch = ($this, value) => {
var oldValue = $this.SEPE_Branch;
$this.SEPE_Branch = value;
if (value != null) {
}
}
static setDYPA_Branch = ($this, value) => {
var oldValue = $this.DYPA_Branch;
$this.DYPA_Branch = value;
if (value != null) {
}
}
static setBusinessEntityErganiSIC = ($this, items) => {
                if (items == null) items = [];
                if ($this.BusinessEntityErganiSIC == null) $this.BusinessEntityErganiSIC = [];

                const copyItems = Common.cloneObject(items);

                while ($this.BusinessEntityErganiSIC.length > 0) {
                    Domain.BusinessEntity.removeBusinessEntityErganiSIC($this, $this.BusinessEntityErganiSIC[0]);
                }

                Domain.BusinessEntity.addManyBusinessEntityErganiSIC($this, copyItems);
            }
static addManyBusinessEntityErganiSIC = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BusinessEntity.addBusinessEntityErganiSIC($this, items[i]);
                }
            }
static addBusinessEntityErganiSIC = ($this, item) => {
                if ($this.BusinessEntityErganiSIC == null) $this.BusinessEntityErganiSIC = [];
                if (item == null || $this.BusinessEntityErganiSIC.indexOf(item) > -1) return;
                $this.BusinessEntityErganiSIC.push(item);
}
static addRangeBusinessEntityErganiSIC = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BusinessEntity.addBusinessEntityErganiSIC($this, item));
            }
static removeBusinessEntityErganiSIC = ($this, item) => {
                if ($this == null || $this.BusinessEntityErganiSIC == null || $this.BusinessEntityErganiSIC.indexOf(item) === -1) return;
                var _index = $this.BusinessEntityErganiSIC.indexOf(item);
                $this.BusinessEntityErganiSIC.splice(_index, 1);
}
static clearBusinessEntityErganiSIC = ($this) => { $this.BusinessEntityErganiSIC = null; }
static setSEPE_DimotikiEnotita = ($this, value) => {
var oldValue = $this.SEPE_DimotikiEnotita;
$this.SEPE_DimotikiEnotita = value;
if (value != null) {
}
}

static GetClassName(): any{return "BusinessEntity";
}
static GetCurrencyAccuracy($this: any): any{return ((CLMS.Framework.Number.Equal(() => $this.CurrencyDecimalAccuracy, () => 0) || CLMS.Framework.Number.Equal(() => $this.CurrencyDecimalAccuracy, () => null)) ? 2 : $this?.CurrencyDecimalAccuracy);
}
static GetPreviousMonday(date: any): any{let weekDay = moment(date).day();
let goback = Joove.Common.safeNumber(-1) * Joove.Common.safeNumber((Joove.Common.safeNumber(6) + Joove.Common.safeNumber(weekDay)));
console.info("WEEKDAY:" + Joove.Common.safeNumber(goback) + " , date " + (moment(date).add(goback, "d")).toDate());
return (moment(date).add(goback, "d")).toDate();
}
static GetYears(): any{let years = [];
for (var i = moment((moment(moment().toDate()).add(5, "y")).toDate()).year(); CLMS.Framework.Number.GreaterThan(() => i, () => 2010); i = Joove.Common.safeNumber(i) - Joove.Common.safeNumber(1)) {
years?.add(i);}

return years;
}
static IsDateAWorkingDay($this: any, date: any): any{if (date == null) {return false;}
return !(Domain.BusinessEntity.IsHoliday($this, date)) && CLMS.Framework.Number.NotEqual(() => moment(date).day(), () => 0) && CLMS.Framework.Number.NotEqual(() => moment(date).day(), () => 6);
}
static IsHoliday($this: any, date: any): any{let holiday = $this?.Holidays?.linq?.where((a) => a?.Date != null && (new Date(new Date(new Date(a?.Date)?.setHours(0, 0, 0, 0))).getTime()) == (new Date(new Date(new Date(date)?.setHours(0, 0, 0, 0))).getTime()))?.firstOrDefault(null);
return holiday != null && !(holiday?.IsWorkingDay);
}
static IsHolidayToday($this: any): any{return Domain.BusinessEntity.IsHoliday($this, moment().toDate());
}
static IsWeekendDay($this: any, dt: any): any{return (CLMS.Framework.Number.Equal(() => moment(dt).day(), () => 0) || CLMS.Framework.Number.Equal(() => moment(dt).day(), () => 6));
}
static ParseBookType(bType: any): any{bType = Joove.Common.replaceAll(bType, " ", "");
return (bType == "Τύπου1" ? Domain.AccountingBookType.Level1 : ((bType == "Τύπου2" ? Domain.AccountingBookType.Level2 : ((bType == "Τύπου3" ? Domain.AccountingBookType.Level3 : Domain.AccountingBookType.Nothing)))));
}
static ParseHasTax(tax: any): any{return (tax == "ΝΑΙ" ? true : false);
}
static ParseIntraCommunityTransactions(itrans: any): any{return (itrans == "ΝΑΙ" ? true : false);
}
static ParseIsPublicSector(se: any): any{return (se == "ΝΑΙ" ? true : false);
}
static ParseKind(kind: any): any{return (kind == "Εταιρεία" ? Domain.BusinessEntityKind.Company : ((kind == "Όμιλος" ? Domain.BusinessEntityKind.Group : ((kind == "Υποκατάστημα" ? Domain.BusinessEntityKind.Branch : Domain.BusinessEntityKind.Nothing)))));
}
static ParseStatus(status: any): any{return (status == "Ενεργή" ? Domain.BusinessEntityStatus.Active : ((status == "Υπό Εκκαθάριση" ? Domain.BusinessEntityStatus.UnderLiquidation : ((status == "Ανενεργή" ? Domain.BusinessEntityStatus.Disabled : Domain.BusinessEntityStatus.Nothing)))));
}
static returnAccountingBookTypeGreekValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? "Επίπεδο 1" : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? "Επίπεδο 2" : "Επίπεδο 3")));
}
static returnAccountingBookTypeIndex(bookType: any): any{switch ((bookType)) {case Domain.AccountingBookType.Level1:
{
return 0;}
case Domain.AccountingBookType.Level2:
{
return 1;}
case Domain.AccountingBookType.Level3:
{
return 2;}
case Domain.AccountingBookType.Nothing:
{
return 3;}
default:
{
return -1;}
}
}
static returnAccountingBookTypeValue(index: any): any{switch ((index)) {case 0:
{
return Domain.AccountingBookType.Level1;}
case 1:
{
return Domain.AccountingBookType.Level2;}
case 2:
{
return Domain.AccountingBookType.Level3;}
case 3:
{
return Domain.AccountingBookType.Nothing;}
default:
{
return Domain.AccountingBookType.Nothing;}
}
}
static returnBusinessEntityKindGreekValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? "Εταιρεία" : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? "Όμιλος" : "Υποκατάστημα")));
}
static returnBusinessEntityKindIndex(kind: any): any{switch ((kind)) {case Domain.BusinessEntityKind.Company:
{
return 0;}
case Domain.BusinessEntityKind.Group:
{
return 1;}
case Domain.BusinessEntityKind.Branch:
{
return 2;}
case Domain.BusinessEntityKind.Nothing:
{
return 3;}
default:
{
return -1;}
}
}
static returnBusinessEntityKindValue(index: any): any{switch ((index)) {case 0:
{
return Domain.BusinessEntityKind.Company;}
case 1:
{
return Domain.BusinessEntityKind.Group;}
case 2:
{
return Domain.BusinessEntityKind.Branch;}
case 3:
{
return Domain.BusinessEntityKind.Nothing;}
default:
{
return Domain.BusinessEntityKind.Nothing;}
}
}
static returnBusinessEntityStatusGreekValue(index: any): any{return (CLMS.Framework.Number.Equal(() => index, () => 0) ? "Ενεργή" : ((CLMS.Framework.Number.Equal(() => index, () => 1) ? "Υπό εκκαθάριση" : "Ανενεργή")));
}
static returnBusinessEntityStatusIndex(status: any): any{switch ((status)) {case Domain.BusinessEntityStatus.Active:
{
return 0;}
case Domain.BusinessEntityStatus.UnderLiquidation:
{
return 1;}
case Domain.BusinessEntityStatus.Disabled:
{
return 2;}
case Domain.BusinessEntityStatus.Nothing:
{
return 3;}
default:
{
return -1;}
}
}
static returnBusinessEntityStatusValue(index: any): any{switch ((index)) {case 0:
{
return Domain.BusinessEntityStatus.Active;}
case 1:
{
return Domain.BusinessEntityStatus.UnderLiquidation;}
case 2:
{
return Domain.BusinessEntityStatus.Disabled;}
case 3:
{
return Domain.BusinessEntityStatus.Nothing;}
default:
{
return Domain.BusinessEntityStatus.Nothing;}
}
}
static RoundCurrencyAmount($this: any, amount: any): any{return Joove.Common.mathRound(amount, Domain.BusinessEntity.GetCurrencyAccuracy($this));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}